import alumniumCover from "./media/alumnium-cover.png";
import altrumCover from "./media/altrum-cover.png";
import bootcamp from "./media/bootcamp.png";
import octomorphosis from "./media/octomorphosis.png";
import travelDevice from "./media/travel-device-poster.png";
import charcoalExperimentIB from "./media/charcoal-experiment-ib.png";
import photographyIB from "./media/photogrpahy-ib.jpg";
import printmakingIB from "./media/printmaking-ib.png";
import collageIB from "./media/collage-ib.jpg";
import girlNextToWindowIB from "./media/girl-next-to-the-window-ib.jpg";
import readingGirlIB from "./media/reading-girl-ib.jpg";
import blackSquare from "./media/black-square.png";
import squareColorExperiment from "./media/square-color-experiment.png";
import stuckPoster from "./media/stuck-cover.png";
import thePreparationPoster from "./media/the-preparation-cover.png";
import endOfSemesterShowPoster from "./media/end-of-semester-ima-poster.jpg";
import aGirlProcreate from "./media/a-girl-procreate.jpg";
import notAMirror from "./media/not-a-mirror.jpg";
import hexagonChairPoster from "./media/hexagon-chair-poster.png";
import timelessTales from "./media/timeless-tales-cover.png";
import diptychAbuDhabi from "./media/diptych-final.jpg";
import itemsToBorrowFromTheRCPoster from "./media/items-to-borrow-from-RC.png";
import linenPurchasePoster from "./media/linen-purchase-poster.png";
import changellengeEducationCase from "./media/challenge-enducation-case.png";
import equiForma from "./media/equi-forma.jpg";
import whisperedHues from "./media/whispered-hues.png"
import coralReefs from "./media/coral-reefs.png"
import nyuadPerformingArtsPoster from "./media/nyuad-performing-arts-poster.png"
import nyuadNationalDayPoster from "./media/nyuad-national-day.jpg"
import doYouEvenCare from "./media/do-you-even-care.png"
import healthFirstAI from "./media/health-first-ai.png"

export const webDevNDes = [
  {
    id: 8,
    name: "Coral Reefs Gone Wild",
    date: "march 2024",
    role: "p5.js, HTML, CSS",
    media: coralReefs,
    description:
      "inspired by movement patterns of coral reefs, this project utilizes coding techniques & physics to mimic the organic movements.",
    link: "https://editor.p5js.org/zhuanya28/full/YtedjLJwr",
  },
  {
    id: 7,
    name: "HealthFirstAI",
    date: "june-october 2023",
    role: "Figma",
    media: healthFirstAI,
    description:
      "designing a website for HealthFirstAI startup.",
    link: "https://www.figma.com/file/JYW5fl6tjMUEFV4Dtnq6rq/web-app-mockup?type=design&node-id=0%3A1&mode=design&t=v9RrtWFGP0EVdVgy-1",
  },
  {
    id: 6,
    name: "EquiForma",
    date: "october 2023 – december 2023",
    role: "p5.js, ml5.js, HTML, CSS",
    media: equiForma,
    description:
      "for a Product Management class at NYU Shanghai, I created a prototype app that utilizes ml5.js Pose detection model as well as OpenAI API to give feedback on the person's squatting technique.",
    link: "https://drive.google.com/file/d/1fKciykyfoCGrwHwN280gawj5Na83i11g/view?usp=share_link",
  },
  {
    id: 5,
    name: "!MIRROR",
    date: "april 2023 – may 2023",
    role: "p5.js, HTML, CSS",
    media: notAMirror,
    description:
      "created a web-based webcamera manipulation project. experiments inspired by Andy Warhol, sketching, pop art and others.",
    link: "https://zhuanya28.github.io/project-b-cclab/",
  },
  {
    id: 4,
    name: "Website Header for Changellenge Education",
    date: "april 2023",
    role: "Figma",
    media: changellengeEducationCase,
    description:
      "designed an interactive website header for Changellenge Education. color palette and logo were set. keywords: official, strong, concise.",
    link: "https://zhuanya28.github.io/project-b-cclab/",
  },
  {
    id: 3,
    name: "Alumnium",
    date: "october 2022 – february 2023",
    role: "Figma",
    media: alumniumCover,
    description:
      "created web design for an education platform. keywords: bright, fresh, simple.",
    link: "https://www.figma.com/file/XSYMVNuXQlJoOuv3Biwpll/alumnium2?node-id=0%3A1&t=KSxaUe7qp96wBsTl-1",
  },
  {
    id: 2,
    name: "Altrum",
    date: "july 2022 – october 2022",
    role: "HTML, CSS, Bootstrap, JS, Node.js",
    media: altrumCover,
    description: "web design and front-end development deploying Bootstrap",
    link: "https://altrum-ed.ru",
  },
  {
    id: 1,
    name: "Web Development Bootcamp Works on Udemy",
    date: "june 2022 – october 2022",
    role: "student",
    media: bootcamp,
    description:
      "practiced HTML, CSS, JS and React as well as learned how to deploy SQL and MongoDB.",
    link: "https://www.udemy.com/course/the-complete-web-development-bootcamp/?kw=web+de&src=sac",
  },
];

export const digitalArtNGraphDesign = [

  {
    id: 17,
    name: "Do you even care?",
    date: "january 2024",
    role: "Adobe Premier Pro, Stable Diffusion, 11Labs",
    media: doYouEvenCare,
    description:
      "this short film is supposed to provoke reflection and raise awareness of not only the algorithmic bias that is reproduced by AI models, but also to highlight the relationship that each of us inevitably has with the technology. Created using Stable Diffusion model on Hugging Face, stock videos from Pexels.com & 11Labs voice generator.",
    link: "https://youtu.be/bm1us5O8Yx0?si=2mrWJTBjkROV9G8I"
  },
  {
    id: 16,
    name: "NYUAD Performing Arts Info Session",
    date: "november 2023",
    role: "InDesign, Figma",
    media: nyuadPerformingArtsPoster,
    description:
      "when working for New York Abu Dhabi Global Outreach Office I have created this poster to attract more NYU Shanghai students to attend a Performing Arts Information Session."
  },
  {
    id: 15,
    name: "Whispered Hues",
    date: "november 2023",
    role: "InDesign, Digital Photography",
    media: whisperedHues,
    description:
      "photobook conveying semivisibility of queer experience.",
    link: "https://drive.google.com/file/d/1XHjFa48OhGPV4_av_H9pR6chxcvIQVzQ/view?usp=share_link"
  },
  {
    id: 14,
    name: "National UAE Day",
    date: "october 2023",
    role: "Figma, Canva",
    media: nyuadNationalDayPoster,
    description:
      "when working for New York Abu Dhabi Global Outreach Office I have created this poster to attract more NYU Shanghai students to attend the National UAE Day celebration."
  },
  {
    id: 13,
    name: "Poster: Linen Purchase",
    date: "may 2023",
    role: "Figma, Canva",
    media: linenPurchasePoster,
    description:
      "as a Summer RA at NYU Shanghai, I created a poster to advertise purchasing Bed Linen from NYU Shanghai, highlighting the price, location and methods in a concise and optimal way.",
  },
  {
    id: 12,
    name: "Poster: Items to Borrow from RC",
    date: "may 2023",
    role: "Figma, Canva",
    media: itemsToBorrowFromTheRCPoster,
    description:
      "as a Summer RA at NYU Shanghai, I renovated the old poster to be more eye-grabbing and concise.",
  },
  {
    id: 11,
    name: "Timeless Tales 永恒故事: short film",
    date: "may 2023",
    role: "iMovie, iPhone 12 Pro Max",
    media: timelessTales,
    description:
      "short film for Experience studio class at NYU Shanghai, where we explored the topic of healthy aging.",
    link: "https://drive.google.com/file/d/1YJXFRSGF4xGvuc3V6zTQypOqdBSVSLaF/view?usp=sharing",
  },
  {
    id: 10,
    name: "Farmer",
    date: "march 2023",
    role: "Procreate",
    media: aGirlProcreate,
    description: "a sketch created in Procreate",
  },
  {
    id: 9,
    name: "OCTOMORPHOSIS",
    date: "march 2023",
    role: "p5.js, HTML",
    media: octomorphosis,
    description:
      "created an interactive world of octopus-inspired creatures using p5.js",
    link: "https://editor.p5js.org/zhuanya28/full/h52OYMQZy",
  },
  {
    id: 8,
    name: "Poster for IMA End-Of-Semester Show",
    date: "december 2022",
    role: "Figma",
    media: endOfSemesterShowPoster,
    description:
      "created a poster using Figma for the End-Of-Semester IMA Show december 2022",
  },
  {
    id: 7,
    name: "Rapid Prototyping Presentation",
    date: "december 2022",
    role: "Figma",
    media: travelDevice,
    description: "",
  },
  {
    id: 6,
    name: "Diptych: Abu Dhabi",
    date: "may 2022",
    role: "Adobe Illustrator, Adobe Photophop",
    media: diptychAbuDhabi,
    description:
      "created a diptych commenting on the contrast between poverty and wealth in Abu Dhabi, extrapolating on other big cities.",
  },
  {
    id: 5,
    name: "Hexagon Chair Poster",
    date: "may 2022",
    role: "Adobe Illustrator",
    media: hexagonChairPoster,
    description:
      "created a promotion poster for the Hexagon Chair using Adobe Illustrator.",
  },
  {
    id: 4,
    name: "Black square",
    date: "february 2022",
    medium: "black and white paper, digitalized using Adobe Illustrator",
    media: blackSquare,
    description:
      "black square was created as an exercise for Communication Lab class at NYU Shanghai. as it can be noticed, there are four parts of this composition, each of them were created using only 1 black square piece of paper. I later digitalized it using tracing tool in Adobe Illustrator.",
  },
  {
    id: 3,
    name: "Square color experiment",
    date: "march 2022",
    medium: "Adobe Illustrator",
    media: squareColorExperiment,
    description:
      "was created as an exercise for Communication Lab class at NYU Shanghai. each square represented a distinct mood reflected through color, shape and composition.",
  },
  {
    id: 2,
    name: "STUCK: short film",
    date: "april 2022",
    medium: "shot on Iphone camera, edited in Adobe Premier Pro",
    media: stuckPoster,
    description:
      "short film created in collaboration with Clarissa for Communication Lab at NYU Shanghai that provides commentary on men's body dysmorphia. full film can be found by clicking the link below.",
    link: "https://drive.google.com/file/d/1gjoUTxODUoUlhcCdfhNyLOKOMCMRsqY2/view?usp=sharing",
  },
  {
    id: 1,
    name: "the preparation: short film",
    date: "april 2022",
    medium: "shot on Iphone camera, edited in Adobe Premier Pro",
    media: thePreparationPoster,
    description:
      "short film created for Communication Lab at NYU Shanghai. captures morning atmosphere and casts one of my best friends. full film can be found by clicking the link below.",
    link: "https://drive.google.com/file/d/13Pq_KjZuajAvC3o37DG9KWzwjMeDEEK1/view?usp=share_link",
  },
];

export const visualArts = [
  {
    id: 1,
    name: "charcoal exploration",
    date: "december 2019",
    medium: "charcoal on board",
    media: charcoalExperimentIB,
    description:
      "The dramatic light was chosen at a stage of taking photograph to convey the evident atmosphere of tension and uneasiness. Moreover, the notion of the coming out- of-darkness figure works well for my goal of depicting loneliness, as it emphasizes the absence of other creatures around. Furthermore, implicit light that shines upon the face allows to display the facial expression in detailed manner. The use of space also contributes to the development of the theme of loneliness as it focuses viewer’s attention on the solemn figure in the positive space. The rest of the space is negative and is mainly used to highlight the emptiness of the outer world that represents the reason behind one’s loneliness. The face is placed not in the centre that ‘leaves space’ for the emotion itself. this space symbolises the splashing emotion that fills out the space around. Speaking of contrast that is evidently present in all of the ways of using the formal elements, it conveys the main theme of the artwork: the extreme emotion of serenity that one feels. Rigid and nealry-monotone strokes in the background emphasise the elaborative and chaotic texture of the face. This creates a contrast between the background and foreground, highlighting the isolation of the figure.",
  },
  {
    id: 2,
    name: "loneliness through digital photography",
    date: "march 2021",
    medium: "digital photography",
    media: photographyIB,
    description:
      "as my final decision was to create a collage, it was crucial to add some color to it. even though black and white, from my perspective are the most appropriate and efficient when conveying serenity and anxiety, the composition needed color. eventually, i have chosen blue and red as their contrast adds up to the tension conveyed. i have edited the photos by enhancing contrast and, sometimes, saturation. i have chosen one of three sizes for each of my photo: A3, A4 or A5. The only A3 became the most abstract (from my perspective) and the least heavy photo: black dissolving figure on the white background. the other photo’s sizes were chosen experimentally: i was dragging the template of how everything will look together on the white ‘wall’ in Photoshop and decided on each size when i liked the way all looks together. i have decided to put photos on the wall by ‘following my guts’ more than ever. i strived to create a balance, however not to lose the tension and despair the i have incorporated in photos. i wanted to balance red and blue photos, while also paying attention to the heaviness or lightness of composition in each photo. even though i had a lot of photographs from my school campus and from my portrait experiments, i decided to include some photos that i have taken using my phone camera in my hometown. that way, i was able to add other character in my work (my grandma) and diversify the locations: forest, road, interior. this helped me compose a multi-faceted environment and highlight the broadness of the loneliness.",
  },
  {
    id: 3,
    name: "printmaking: loneliness in forest",
    date: "december 2020",
    medium: "high printmaking on paper",
    media: printmakingIB,
    description:
      "the shapes that I have used were developed in the process of experimentation. the contrast of sizes helps convey the feeling of tension and anxiety. Moreover, the shapes of trees without leaves embeds the perdition atmosphere, which adds up to the ambience of a deserted place. I have integrated various shapes to compose a balanced landscape. throughout the process, I have carved numerous of these forms before deciding on the key ones. moreover, the repetition of these shapes imply the connection between these three relief printmaking works. tiny human figure that drastically contrasts with the massive shapes of ground conveys the feeling of serenity. experiments with napkins, thinner and wrappings to create a range and textures that would convey the incentive to investigate and explore (just as the forest atmosphere provokes to do). using napkin and thinner has helped me to create a “fading” effect that is explicit on the final work3. this adds up to the atmosphere of deserted and evolving place. lines that also convey the feeling of movement -> dynamic nature of the forest. but quite circular, closed arrangement that conveys the feeling of calmness and safety. moreover, as the shapes used are highly graphic, they facilitate the atmosphere of dynamics and evolving place. the motive of closed space combined with the sufficient amount of white to create the freshness and freedom (as i feel in forest) aligned with the solidness and stability of landscape and basic shapes. the empty wide space above the ground adds up to the feeling of serenity and deserted space. overall, i believe that the effective use of space was developed throughout the experiments that I have conducted. I am happy with the result and hope to continue experimenting with space further in my other projects.",
  },
  {
    id: 4,
    name: "collage experiment",
    date: "january 2021",
    medium: "paper, cardboard",
    media: collageIB,
    description:
      "i have used the same colors for all of the pieces: yellow, black, white and a bit of pink and blue. most of the photos were grey-scaled to highlight the inter-connectivity between them. this allowed me to develop the idea of a shared serenity that is exhibited in my project. the final composition that i have chosen is a narrowed down version of an initial idea. this choice was prompted by the limited space that i had for this piece of art for my composition. in addition, this helped me convey the idea of chaotic, but organized inherited serenity. this collage contains numerous different shapes that i have carved to construct the ‘flowing’ effect. moreover, this helped me to diversify techniques that i have implemented throughout the process. i tried to create carvings that wouldn’t resemble the initial position of the bodies or surroundings. instead, i used these parts to create a new, imaginary space and shape. the repetition of the color and shapes was used to highlight the connectivity between the pieces. this facilitated the creation of a certain ‘flow’ and dynamic nature of the serenity that i strived to display. i am more than satisfied with the results i have achieved. i have undertaken numerous approaches to create a balanced, however unique and dynamic compositions. some of them were connected by the pieces of the same photographs, some of them include a separate and distinct pieces of pictures. it was extremely interesting and satisfying when following my inner instincts, composing the photos together. moreover, creating the project taking my family archive as a resource added up to the personal engagement that i have experienced during the process.",
  },
  {
    id: 5,
    name: "girl next to the window",
    date: "october 2020",
    medium: "oil on paper",
    media: girlNextToWindowIB,
    description:
      "Shadows and sun rays that falls on the interior and the figure from the outside, highlights the difference between the outer world and the interior. It provides an unsettling feeling and helps transmit the atmosphere of loneliness. Rigid lines created by the minimalistic interior design and shadows that geometrically fall on the floor and walls help draw attention of the viewer to the solemn human figure. Moreover, these lines create shapes that balance each other and form the perspective. Slightly unrealistic perspective provide the feeling of mystery and uneasiness, which contributes to the overall idea of tension and solemnity. this work showcases numerous types of contrasts: tiny figure of a girl vs massive traits of interior, cold colors inside vs warm light outdoors, rigid lines of the interior vs smooth flow of horizon line.",
  },
  {
    id: 6,
    name: "reading girl",
    date: "february 2019",
    medium: "oil on paper",
    media: readingGirlIB,
    description:
      "The light that was depicted in my photographs has helped me to sort out the right shadows and successfully depict the soft, but direct rays of sun. The use of light in this project is vital, it, just like soft box draws attention to the human figure the emotion it has. softness of the colors convey the intimate atmosphere and facilitates the main idea of human figure’s lost in the thoughts, highlighting the loneliness she experiences. the composition is centred around the sole human figure which adds up to the main idea of the project.",
  },
];
